/** @format */

import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { MainMarketingContentComponent } from './components/main-marketing-content/main-marketing-content.component';
import { MarketingStoryComponent } from './components/marketing-story/marketing-story.component';
import { MediaModule } from '@shared/media/components';
import { NgModule } from '@angular/core';
import { PromotionBannerComponent } from './components/promotion-banner/promotion-banner.component';
import { WindowModule } from '@shared/data-access/services';

@NgModule({
	imports: [CommonModule, HmfButtonComponent, MediaModule, WindowModule],
	exports: [MainMarketingContentComponent, MarketingStoryComponent, PromotionBannerComponent],
	declarations: [MainMarketingContentComponent, MarketingStoryComponent, PromotionBannerComponent]
})
export class MarketingWidgetsModule {}
